import { Flow } from '@integration-app/sdk'
import { useDebounceValue } from 'usehooks-ts'

import { Combobox, SelectItemType, ComboboxProps } from 'components/Select'

import { OptionItem } from './components'
import useIntegrationElement from '../hooks/useIntegrationElement'

export function DataSourceKeyComboboxSelect({
  value,
  onChange,
  name,
  ...props
}: Omit<ComboboxProps, 'items' | 'value' | 'onChange'> & {
  value?: string
  onChange: (value?: string) => void
  name?: string
}) {
  const [debouncedSearchValue, setDebouncedSearchValue] = useDebounceValue(
    '',
    150,
  )
  const { items } = useIntegrationElement<Flow>({
    route: 'data-sources',
  })

  const options = items?.map((ds) => ({
    value: ds.key,
    label: ds.name,
  }))

  const filteredOptions = options?.filter((o) => {
    return [o.label, o.value]
      .map((x) => x.toLowerCase())
      .some((x) => x.includes(debouncedSearchValue.toLowerCase()))
  })
  const selectedOption = options?.find((o) => o.value === value)

  function handleChange(item: SelectItemType) {
    onChange(item?.value)
  }

  return (
    <Combobox
      items={filteredOptions}
      value={selectedOption}
      onValueChange={handleChange}
      placeholder={'Select a data source'}
      onSearchInputChange={setDebouncedSearchValue}
      TriggerTextComponent={(props) => (
        <OptionItem asTrigger name={name} {...props} />
      )}
      ItemTextComponent={(props) => <OptionItem {...props} />}
      {...props}
    />
  )
}
